(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["ReactProgressiveImage"] = factory(require("react"));
	else
		root["ReactProgressiveImage"] = factory(root["React"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProgressiveImage = function (_React$Component) {
	  _inherits(ProgressiveImage, _React$Component);
	
	  function ProgressiveImage(props) {
	    _classCallCheck(this, ProgressiveImage);
	
	    var _this = _possibleConstructorReturn(this, (ProgressiveImage.__proto__ || Object.getPrototypeOf(ProgressiveImage)).call(this, props));
	
	    _this.loadImage = function (src) {
	      // If there is already an image we nullify the onload
	      // and onerror props so it does not incorrectly set state
	      // when it resolves
	      if (_this.image) {
	        _this.image.onload = null;
	        _this.image.onerror = null;
	      }
	      var image = new Image();
	      _this.image = image;
	      image.onload = _this.onLoad;
	      image.onerror = _this.onError;
	      image.src = src;
	    };
	
	    _this.onLoad = function () {
	      // use this.image.src instead of this.props.src to
	      // avoid the possibility of props being updated and the
	      // new image loading before the new props are available as
	      // this.props.
	      _this.setState({
	        image: _this.image.src,
	        loading: false
	      });
	    };
	
	    _this.onError = function (errorEvent) {
	      var onError = _this.props.onError;
	
	      if (onError) {
	        onError(errorEvent);
	      }
	    };
	
	    _this.state = {
	      image: props.placeholder,
	      loading: true
	    };
	    return _this;
	  }
	
	  _createClass(ProgressiveImage, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var src = this.props.src;
	
	      this.loadImage(src);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      var src = nextProps.src,
	          placeholder = nextProps.placeholder;
	      // We only invalidate the current image if the src has changed.
	
	      if (src !== this.props.src) {
	        this.setState({ image: placeholder, loading: true }, function () {
	          _this2.loadImage(src);
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.image) {
	        this.image.onload = null;
	        this.image.onerror = null;
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _state = this.state,
	          image = _state.image,
	          loading = _state.loading;
	      var children = this.props.children;
	
	      if (!children || typeof children !== "function") {
	        throw new Error("ProgressiveImage requires a function as its only child");
	      }
	      return children(image, loading);
	    }
	  }]);
	
	  return ProgressiveImage;
	}(React.Component);
	
	exports.default = ProgressiveImage;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// react-progressive-image.min.js